<div [class.text-danger]="amount < 0" [class.currency-inline]="inline" [ngClass]="getAlignmentClass()">{{ amount | ulticurrency:format:undefined:showFullAmount }}</div>
